(() => {
  function init() {
    const menu = document.querySelector('.ps-menu');
    if (menu && !menu.dataset.ready) {
      menu.dataset.ready = 'true';
      menu.addEventListener('click', () => {
        const expanded = menu.getAttribute('aria-expanded') !== 'true';
        menu.setAttribute('aria-expanded', String(expanded));
        menu.setAttribute('aria-label', expanded ? 'Close menu' : 'Open menu');
        document.getElementById('ps-navigation')?.classList.toggle('is-open', expanded);
      });
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && menu.getAttribute('aria-expanded') === 'true') menu.click();
      });
    }
    document.querySelectorAll('[data-filter]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        document.querySelectorAll('[data-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        document.querySelectorAll('[data-system]').forEach(card => { card.hidden = button.dataset.filter !== 'all' && card.dataset.system !== button.dataset.filter; });
      });
    });
    document.querySelectorAll('[data-gallery-src]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const gallery = button.closest('.ps-gallery');
        const image = gallery.querySelector('[data-gallery-main]');
        image.src = button.dataset.gallerySrc;
        image.alt = button.dataset.galleryAlt;
        gallery.querySelectorAll('[data-gallery-src]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        const inset = gallery.querySelector('.ps-gallery-inset');
        if (inset) inset.hidden = button !== gallery.querySelector('[data-gallery-src]');
        const label = gallery.querySelector('.ps-gallery-label');
        if (label) label.hidden = button !== gallery.querySelector('[data-gallery-src]');
      });
    });
    document.querySelectorAll('[data-variant-select]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      const update = () => {
        const root = select.closest('[data-product-studio]');
        const option = select.selectedOptions[0];
        root.querySelector('[data-price]').textContent = new Intl.NumberFormat('en-GB', {style:'currency',currency:'GBP'}).format(Number(option.dataset.price) / 100);
        root.querySelectorAll('[data-pack-variant]').forEach(pack => { pack.hidden = pack.dataset.packVariant !== select.value; });
        const pack = root.querySelector('[data-pack-variant="' + select.value + '"]');
        if (pack) {
          const quantities = Array.from(pack.querySelectorAll('li span:last-child')).map(x => x.textContent);
          root.querySelectorAll('[data-component-quantity]').forEach(x => { x.textContent = quantities[Number(x.dataset.componentQuantity)] || ''; });
          const manifold = root.querySelector('[data-showcase-manifold]');
          if (manifold) { manifold.src = pack.dataset.manifoldSrc; manifold.alt = pack.dataset.manifoldPorts + '-port stainless steel manifold'; }
        }

        if (pack) { const thumb = root.querySelector('[data-manifold-thumb]'); const inset = root.querySelector('[data-manifold-inset]'); const alt = pack.dataset.manifoldPorts + '-port manifold example for this core pack'; if (inset) { inset.src = pack.dataset.manifoldSrc; inset.alt = alt; } if (thumb) { thumb.dataset.gallerySrc = pack.dataset.manifoldSrc; thumb.dataset.galleryAlt = alt; thumb.querySelector('img').src = pack.dataset.manifoldSrc; if (thumb.getAttribute('aria-pressed') === 'true') { root.querySelector('[data-gallery-main]').src = pack.dataset.manifoldSrc; root.querySelector('[data-gallery-main]').alt = alt; } } }
        const unavailable = option.dataset.available !== 'true';
        root.querySelectorAll('[data-add-cart], [data-buy-now]').forEach(button => { button.disabled = unavailable; });
        const label = root.querySelector('[data-buy-label]');
        if (label) label.textContent = unavailable ? 'Unavailable' : 'Add to cart';
        const stickyPrice = root.querySelector('[data-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = root.querySelector('[data-price]').textContent;
        const url = new URL(location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url);
        document.querySelectorAll('script[type="application/ld+json"]').forEach(script => {
          try { const data = JSON.parse(script.textContent); if (data['@type'] === 'Product' && data.offers) { data.offers.price = Number(option.dataset.price) / 100; const offerURL = new URL(data.url); offerURL.searchParams.set('variant', select.value); data.offers.url = offerURL.href; script.textContent = JSON.stringify(data); } } catch (_) { /* Leave unrelated structured data unchanged. */ }
        });
        const quote = root.querySelector('[data-quote-link]');
        if (quote) { const target = new URL(quote.href); target.searchParams.set('area', option.textContent.trim()); quote.href = target.pathname + target.search; }
      };
      select.addEventListener('change', update);
      update();
    });
    const enquiry = document.querySelector('.ufh-enquiry form');
    if (enquiry && !enquiry.dataset.studioPrefilled) {
      enquiry.dataset.studioPrefilled = 'true';
      enquiry.addEventListener('invalid', event => { const details = event.target.closest('details'); if (details) details.open = true; }, true);
      const params = new URLSearchParams(location.search);
      ['board', 'fixing', 'controls'].forEach(key => {
        const value = params.get(key);
        if (!value) return;
        const field = document.createElement('input'); field.type = 'hidden'; field.name = 'contact[' + key + ' preference]'; field.setAttribute('value', value.slice(0,160)); field.setAttribute('data-ufh-restore', ''); enquiry.appendChild(field);
        const summary = document.createElement('p'); summary.className = 'ps-preference-summary'; summary.textContent = 'For your quote: ' + value.slice(0,160); enquiry.prepend(summary);
      });

      const systems = {'screed-system-kit':'Screed system','xps-r-300-overlay-kit':'XPS insulated overlay','heatbacker-tiled-overlay-kit':'Heatbacker tiled overlay'};
      const floor = enquiry.querySelector('[name="contact[Floor system]"]');
      const area = enquiry.querySelector('[name="contact[Heated area m2]"]');
      const state = enquiry.querySelector('[data-ufh-enquiry-state]')?.dataset.ufhEnquiryState;
      if (state === 'idle') {
        const preferences = ['board','fixing','controls'].map(key => params.get(key)).filter(Boolean).map(value => value.slice(0,160));
        const message = enquiry.querySelector('[name="contact[body]"]');
        if (message && !message.value && preferences.length) { message.value = 'Please quote for: ' + preferences.join('; ') + '.\n\nProject details: '; }

        if (floor && systems[params.get('system')]) floor.value = systems[params.get('system')];
        const number = Number.parseFloat(params.get('area'));
        if (area && Number.isFinite(number) && number > 0 && number <= 10000) area.value = String(number);
      }
    }
    const dialog = document.querySelector('.ps-video-dialog');
    if (dialog && !dialog.dataset.ready) {
      dialog.dataset.ready = 'true';
      const video = dialog.querySelector('video');
      document.querySelectorAll('[data-open-film]').forEach(button => button.addEventListener('click', () => { dialog.showModal(); const start = Number(button.dataset.filmStart || 0); if (video.readyState > 0) video.currentTime = start; else video.addEventListener('loadedmetadata', () => { video.currentTime = start; }, {once:true}); video.play().catch(() => {}); }));
      dialog.querySelector('[data-close-film]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => video.pause());
      dialog.querySelectorAll('[data-film-seek]').forEach(button => button.addEventListener('click', () => { video.currentTime = Number(button.dataset.filmSeek); video.play().catch(() => {}); }));
      dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
